import * as React from 'react';
import openBrowserTips from '../../img/tips-new.png';
import './index.less'

const demoImage = 'https://diy-assets.msstatic.com/game-release/tips266.png';

function TipsPicture(props: any) {
  const { visible, onClose } = props;
  return (
    <div onClick={(eve:any) =>{
      eve.stopPropagation();
      eve.cancelBubble = true;
      onClose(false)
    }} className={`wx-tips-warper ${visible ? 'active' : ''}`}>
      <div className='t-w-img-w'>
        <img src={openBrowserTips} alt={openBrowserTips} />
      </div>
    </div>
  )
}

export default TipsPicture;
